<div class="pre-registration-wrapper {{ isMobile ? 'is-mobile' : '' }}">
	<div class="pre-registration-container">
		<ng-container *ngIf="isLoading">
			<div class="card"><nz-skeleton></nz-skeleton></div>
			<div class="card"><nz-skeleton></nz-skeleton></div>
		</ng-container>
		<ng-container *ngIf="!isLoading">
			<div *ngIf="!is404" class="header">
				<img src="assets/images/svgs/moniepoint_logo.svg" />
				<div class="text flex flex-col gap-1">
					<div *ngIf="errorMessage && !is404 ;else other_content">
						<p class="title">You’ve been invited to join Moniepoint</p>
					</div>

					<ng-template #other_content><p class="title">{{firstName}} has invited you to join Moniepoint</p></ng-template>

					<p class="description">Banking On Point</p>
				</div>
			</div>

			<div *ngIf="is404" class="invalid-error">
				<img class="i-image" src="assets/images/svgs/referrals-pre-registration/404.svg" />
				<div class="flex flex-col">
					<p class="title">Invalid Referral Code</p>
					<p class="description">Sorry, the referral code is invalid.</p>
				</div>
			</div>

		<app-joining-list-item [is404]="is404"></app-joining-list-item>

		<app-joining-form [referralCode]="referralCode" [is404]="is404"></app-joining-form>
		<div *ngIf="!is404" class="joining-text">
			<p class="text">We will share very limited information about your account set-up and activity with the person who referred you to Moniepoint. This ensures that the appropriate parties can receive referral rewards if applicable.</p>
		</div>
		</ng-container>
	</div>
</div>
